import React from "react";
import moment from "moment";

import "./Copyright.scss";

function GameCopyright() {
  return (
    <div className="copyright">
      Copyright © 2005-{moment().format('YYYY')} by Bear Bibeault
      <br />
      All rights reserved
      <br />
      BlackBox™ is a registered trademark of Parker Brothers Games
    </div>
  );
}

export default GameCopyright;
